<template>
  <div
    class="border-input-border relative flex h-[calc(100vh-370px)] flex-col overflow-hidden rounded-md border"
  >
    <div
      class="border-input-border text-selected-tab-text sticky top-0 z-20 grid flex-shrink-0 border-b bg-steel-100 text-left text-sm"
      :class="headerGridClass"
    >
      <slot name="header" />
    </div>

    <slot
      v-if="data?.length === 0"
      name="emptyState"
    />

    <div
      v-else
      class="flex-1 overflow-y-auto"
    >
      <div
        v-for="(item, index) in data"
        :key="getItemKey(item)"
        :class="[
          'text-selected-tab-text hover:bg-info-subtle-bg border-input-border grid items-center border-b text-left text-sm',
          rowGridClass,
          showDetail && selectedItem === getItemKey(item)
            ? 'selected-row-item'
            : '',
        ]"
        @click="onClick(item)"
      >
        <slot
          name="row"
          :item="item"
          :index="index"
        />
      </div>
    </div>

    <div
      class="text-selected-tab-text sticky bottom-0 z-20 flex h-14 flex-shrink-0 items-center justify-center border-t bg-white px-3 py-2 text-sm"
    >
      <p
        v-if="showTotalResultsText"
        class="absolute left-2 text-xs font-normal text-steel-800"
      >
        {{ resultsText }}
      </p>

      <pagination
        v-if="showPagination && pagination.totalPages > 1"
        :equivalent="true"
        :selected-page="parseInt(pagination?.currentPage || 1)"
        :total-pages="parseInt(pagination?.totalPages || 1)"
        @select-page="onSelectPage"
      ></pagination>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
// import { LightPagination as Pagination } from '@/components';
import Pagination from '@/components/LightPagination.vue';

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
  pagination: {
    type: Object,
    default: () => ({
      currentPage: 1,
      totalPages: 1,
    }),
  },
  showDetail: {
    type: Boolean,
    default: false,
  },
  selectedItem: {
    type: [Number, String, null],
    default: null,
  },
  showPagination: {
    type: Boolean,
    default: true,
  },
  headerGridClass: {
    type: String,
    default: 'grid-cols-8',
  },
  rowGridClass: {
    type: String,
    default: 'grid-cols-8',
  },
  getItemKey: {
    type: Function,
    default: (item) => item.id,
  },
  showTotalResultsText: {
    type: Boolean,
    default: false,
  },
  customResultsText: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click', 'select-page']);

const resultsText = computed(() => {
  if (props?.customResultsText) {
    return props.customResultsText;
  }
  return `Showing ${props?.data?.length} of ${props?.pagination?.totalRecords} result${props?.pagination?.totalRecords == 1 ? '' : 's'}`;
});

const onSelectPage = (page) => {
  emit('select-page', page);
};

const onClick = (item) => {
  emit('click', item);
};
</script>

<style scoped>
.topShadow {
  box-shadow: 0px -1px 6px 0px rgba(160, 160, 160, 0.22);
}
</style>
